exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-responsive[data-v-c657916e] {\n    overflow: visible;\n}\n.box-primary[data-v-c657916e] {\n    margin: 0;\n}\n", ""]);

// exports
